import React from "react";
import "../styles/Kyc.css";
import kycImg from "../assets/photos/kyc-verification.png";

function Kyc() {
  return (
    <div className="kyc-wrapper">

      {/* HERO */}

      <section className="kyc-hero">

        <h1>Know Your Customer (KYC)</h1>

        <p>
          Secure your banking experience by keeping your KYC details updated.
          KYC verification helps protect customers and ensures safe banking
          services.
        </p>

      </section>



      {/* WHAT IS KYC */}

      <section className="kyc-about">

        <div className="kyc-about-grid">

          <div className="kyc-about-text">

            <h2>What is KYC?</h2>

            <p>
              KYC (Know Your Customer) is a mandatory process used by banks
              to verify the identity and address of customers before providing
              financial services.
            </p>

            <p>
              This verification helps banks prevent fraud, money laundering,
              and financial crimes while ensuring secure banking services
              for all customers.
            </p>

          </div>

          <div className="kyc-about-image">

            <img src={kycImg} alt="KYC Verification"/>

          </div>

        </div>

      </section>



      {/* WHY KYC */}

      <section className="kyc-importance">

        <h2>Why KYC is Important</h2>

        <div className="kyc-importance-grid">

          <div className="kyc-importance-card">
            <h3>Fraud Prevention</h3>
            <p>KYC helps banks identify customers and prevent fraud.</p>
          </div>

          <div className="kyc-importance-card">
            <h3>Secure Banking</h3>
            <p>Ensures safe and trusted banking services for customers.</p>
          </div>

          <div className="kyc-importance-card">
            <h3>Regulatory Compliance</h3>
            <p>Banks follow regulatory guidelines issued by authorities.</p>
          </div>

          <div className="kyc-importance-card">
            <h3>Access to Services</h3>
            <p>Customers with completed KYC enjoy full banking benefits.</p>
          </div>

        </div>

      </section>



      {/* DOCUMENTS */}

      <section className="kyc-documents">

        <h2>Documents Required for KYC</h2>

        <div className="kyc-documents-grid">

          <div className="kyc-doc-card">Aadhaar Card</div>

          <div className="kyc-doc-card">PAN Card</div>

          <div className="kyc-doc-card">Passport</div>

          <div className="kyc-doc-card">Driving License</div>

          <div className="kyc-doc-card">Voter ID</div>

          <div className="kyc-doc-card">Address Proof</div>

        </div>

      </section>



      {/* PROCESS */}

      <section className="kyc-process">

        <h2>KYC Update Process</h2>

        <div className="kyc-process-grid">

          <div className="kyc-process-card">
            <span>1</span>
            <p>Visit the nearest bank branch.</p>
          </div>

          <div className="kyc-process-card">
            <span>2</span>
            <p>Fill the KYC update form.</p>
          </div>

          <div className="kyc-process-card">
            <span>3</span>
            <p>Submit required documents.</p>
          </div>

          <div className="kyc-process-card">
            <span>4</span>
            <p>Verification by bank officials.</p>
          </div>

          <div className="kyc-process-card">
            <span>5</span>
            <p>KYC update confirmation.</p>
          </div>

        </div>

      </section>



      {/* GUIDELINES */}

      <section className="kyc-guidelines">

        <h2>Important Guidelines</h2>

        <ul className="kyc-guideline-list">

          <p>1) Ensure that your documents are valid and not expired.</p>

          <p>2) KYC must be updated periodically as per bank rules.</p>

          <p>3) Incomplete KYC may restrict certain banking transactions.</p>

          <p>4) Always submit documents through official bank channels.</p>

        </ul>

      </section>



      {/* DOWNLOAD */}

      <section className="kyc-download">

        <h2>KYC Form Download</h2>

        <a href="/download-center" className="kyc-download-btn">
          Download KYC Form
        </a>

      </section>



      {/* FAQ */}

      <section className="kyc-faq">

        <h2>Frequently Asked Questions</h2>

        <div className="kyc-faq-box">

          <h4>What happens if KYC is not completed?</h4>
          <p>
            Banking transactions may be restricted until KYC verification
            is completed.
          </p>

        </div>

        <div className="kyc-faq-box">

          <h4>How often should KYC be updated?</h4>
          <p>
            KYC updates depend on bank guidelines and customer risk category.
          </p>

        </div>

        <div className="kyc-faq-box">

          <h4>Can KYC be done online?</h4>
          <p>
            Some banks provide online or video KYC options for customer
            convenience.
          </p>

        </div>

      </section>

    </div>
  );
}

export default Kyc;